<template>
  <div class="content">
    <div class="container px-0">
      <div class="row w-100 mx-0">
        <div class="col-md-12 col-12 px-0">
          <top-navbar title="OWNER" search="false"></top-navbar>
        </div>
      </div>
      <div class="row pb-5 mx-0 position-relative" style="height: 90vh;">
        <div class="col-md-3 mt-5">
          <button type="button" class="generateBtn" style="padding: 1rem 3rem;">QR Code</button>
        </div>
        <div class="col-md-6 mt-5">
          <label for="webUrl" class="font-weight-bold">Insert website/URL</label>
          <div class="d-flex">
            <input type="text" class="form-control" id="webUrl" v-model="webUrl">
            <button type="button" @click="generateQrCode" class="generateBtn">Generate Code</button>
          </div>
          <div class="qrContainer">
            <img v-if="!qrCodeUrl" src="/img/qr.svg" alt="" width="300">
            <img v-else :src="qrCodeUrl" alt="QR Code" ref="qrImage" width="300" />
          </div>
        </div>
        <div class="col-md-3 mt-5"></div>
        <button type="button" @click="downloadPdf" class="downloadBtn" style="padding: 1rem 2rem;">Download PDF</button>
      </div>
    </div>

    <div v-if="isLoading" class="overlay">
      <img src="/img/loading.gif" alt="GIF" width="30" height="30" class="mx-auto d-block" style="margin-top: 20%">
    </div>

  </div>
</template>
<script>
  import TopNavbar from '../layout/TopNavbar'
  import QRCode from 'qrcode'
  import jsPDF from 'jspdf'

  export default {
    components: {
      TopNavbar
    },
    data () {
      return {
        jwtToken: this.$cookies.get('token') || null,
        webUrl: '',
        qrCodeUrl: ''
      }
    },
    methods: {
      async generateQrCode () {
        this.qrCodeUrl = await QRCode.toDataURL(this.webUrl)
        setTimeout(() => {
          this.$toastr.s("Generated Successfully", "Success");
        }, 500);
      },
      downloadPdf () {
        const doc = new jsPDF({
          orientation: 'portrait',
          unit: 'pt',
          format: 'a4'
        })

        const pageWidth = doc.internal.pageSize.getWidth()
        const topMargin = 50

        // Title
        doc.setFontSize(18)
        doc.setFont('helvetica', 'bold')
        doc.text(this.webUrl, pageWidth / 2, topMargin, { align: 'center' })

        // QR Code Image
        const qrSize = 350
        const qrX = (pageWidth - qrSize) / 2
        const qrY = topMargin + 80
        doc.addImage(this.qrCodeUrl, 'PNG', qrX, qrY, qrSize, qrSize)

        // Footer Text
        doc.setFontSize(18)
        doc.setFont('helvetica', 'bold')
        doc.text('Generated by', pageWidth / 2, qrY + qrSize + 80, { align: 'center' })
        doc.text('GK-Soft', pageWidth / 2, qrY + qrSize + 100, { align: 'center' })

        doc.save('qr-code.pdf')
      }
    }
  }

</script>
<style scoped>
input{
  border-radius: 0;
  border: 1px solid;
  padding: 28px;
  margin-right: 1rem;
}
.generateBtn, .downloadBtn{
  padding: 5px 35px;
  background: linear-gradient(179.48deg, #FD7902 36.9%, #FF0101 99%);
  color: #fff;
  border: unset;
  border-radius: 8px;
}
.downloadBtn{
  position: absolute;
  right: 2rem;
  bottom: 2rem;
}
.qrContainer{
  text-align: center;
  border: 1px solid;
  padding: 5rem 0;
  margin-top: 2rem;
}

</style>
